import { Modals } from 'store/atoms/typings'

const SKIP_ANALYTICS_MODAL_IDS: Modals[] = ['Statement']

/** Checks to see if a modal is open to run their analytics over dashboard analytics */
const shouldAccountDashboardSkipAnalytics = (modalId: string): boolean =>
  SKIP_ANALYTICS_MODAL_IDS.includes(modalId as Modals)

export default shouldAccountDashboardSkipAnalytics
